<template>
	<div id="LegalDocuments" class="legal-documents">
        <nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromLegalDocuments" @change="getAllLegalDocuments(1)">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToLegalDocuments" @change="getAllLegalDocuments(1)">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchOrders"
					v-model="searchLegalDocuments"
					v-on:keyup.enter="getAllLegalDocuments(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllLegalDocuments(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsLegalDocument" @change="changeQRowsLegalDocument">
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
			</div>
		</nav>

        <table class="table table-sm table-hover table-12">
            <thead>
                <tr>
                    <th class="text-center">#</th>
                    <th class="text-center">ID</th>
                    <th class="text-center">Tipo</th>
                    <th class="text-center">Folio</th>
                    <th class="text-center">Fecha</th>
                    <th class="text-center">Destinatario</th>
                    <th class="text-center">RUT</th>
                    <th class="text-center">Monto</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in listLegalDocuments" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">{{ item.id }}</td>
                    <td>{{ item.type_legal_document }}</td>
                    <td class="text-center">{{ item.legal_document_number }}</td>
                    <td class="text-center">{{ item.date_legal_document | formatDate }}</td>
                    <td>{{ item.receiving_entity_name }}</td>
                    <td class="text-center">{{ item.receiving_entity_document_number }}</td>
                    <td class="text-right">{{ methodFormatNumber(item.total) }}</td>
                    <td class="text-right">
						<i class="fas fa-file-download pointer margin-left5 text-info" v-if="item.url != ''" title="Decargar PDF" @click="downloadPDF(item.url)"></i>
						<i class="fas fa-file-download pointer margin-left5 text-warning" v-if="item.url_assignable != ''" title="Decargar PDF Cedible" @click="downloadPDF(item.url_assignable)"></i>
						<i class="far fa-paper-plane text-primary pointer"
							v-if="item.legal_document_number == 0"
							:title="'Generar ' + item.type_legal_document"
							@click="sendToRegulatoryEntityLocal(item)"></i>
						<i class="fas fa-print pointer margin-left5" v-else @click="toPrintFacturacionCL(item.type_legal_document_id, item.legal_document_number)"></i>
					</td>
                </tr>
            </tbody>
        </table>
        <pagination :pagination="paginationLegalDocuments" @getAllList="getAllLegalDocuments"></pagination>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import legalDocument from '@/mixins/legalDocuments'
import facturacionCLPrint from '@/mixins/facturacionCLPrint.js'

import Pagination from '@/components/Pagination.vue'
export default {
	name: 'LegalDocuments',
	mixins: [axiosAction, errors, mixin, legalDocument, facturacionCLPrint],
	data() {
		return {
		}
	},
	computed: {
	},
	methods: {
        getAllLegalDocumentsResultLocal(response){ },
		initModuleLocal() {
			this.setTitleModule('Documentos Legales')
			this.setSubTitleModule('')
			this.qRowsLegalDocument = (localStorage.getItem('qRowsLegalDocument') === null) ? this.qRowsLegalDocument : localStorage.getItem('qRowsLegalDocument')
			this.dateFromLegalDocuments = this.currentDate(-30)
			this.dateToLegalDocuments = this.currentDate()
			this.initMixinFactutacionCLPrint()
			this.setListeningLegalDocument()
            this.getAllLegalDocuments()
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllLegalDocumentsResult': this.getAllLegalDocumentsResult(response); break;
				case 'sendToRegulatoryEntityResult': this.sendToRegulatoryEntityResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		sendToRegulatoryEntityLocal(item) {
			this.sendToRegulatoryEntity(item.id)
		},
		sendToRegulatoryEntityResultLocal(response) {
			
		}
	},
	components: {
		'pagination': Pagination,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>